<template>
    <div>
        <div
            v-bind:class="headerClassObject"
            class="section-header-collapsible"
            v-on:click="toggleShown">
            <div class="d-flex align-items-center justify-content-between">
                <div class="order-2 w-100">
                    <slot name="title">
                        {{ title }}
                    </slot>
                </div>
                <div v-bind:class="chevronClassObject">
                    <pc-bs-icon
                        name="chevron-right"
                        v-bind:rotate-on="shown" />
                </div>
            </div>
            <hr
                v-if="shown && leftOriented"
                class="flex-grow-1 ms-3" />
        </div>
        <pc-transition transition="slide">
            <div v-show="shown">
                <slot />
            </div>
        </pc-transition>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/pcComponentDefaults.i18n";
    export default {
        props: {
            title: { type: String, required: false, default: null },
            leftOriented: { type: Boolean, required: false, default: false },
            collapsible: { type: Boolean, required: false, default: true },
            open: { type: Boolean, required: false, default: true }
        },
        data: function () {
            return {
                shown: this.open
            };
        },
        computed: {
            headerClassObject() {
                return { "d-flex": this.leftOriented, "align-items-center": this.leftOriented };
            },
            chevronClassObject() {
                return {
                    "align-self-start": !this.leftOriented,
                    "me-1": this.leftOriented,
                    "order-1": this.leftOriented,
                    "order-3": !this.leftOriented
                };
            },
            titleDisplay() {
                return this.title ?? this.pcSectionDefaultTitle;
            },
            ...mapI18n({ pcSectionDefaultTitle: KEYS.pcSectionDefaultTitle }, NAMESPACE)
        },
        methods: {
            toggleShown() {
                if (this.collapsible) {
                    this.shown = !this.shown;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .section-header-collapsible {
        cursor: pointer;
    }
</style>
